import React from "react";
//import Header from '../components/Header';
import Footer from '../components/Footer';
import SubHeader from "../components/SubHeader";
import Testimonials from "../components/Testimonials";


function About() {
    return (
        <>
            <SubHeader />
            <main>
                <section className="page-header" style={{ backgroundColor: "#3c4c24" }}>
                    <div className="page-header__bg"></div>
                    <div className="container">
                        <ul className="villoz-breadcrumb list-unstyled" >
                            <li><a style={{ color: "white" }} href="/">Home</a></li>
                            <li><span style={{ color: "white" }}>About Us</span></li>
                        </ul>
                        <h2 style={{ color: "white" }} className="page-header__title">About Us</h2>
                    </div>
                </section>

                {/* Section: Ayubowan from Hanthana House */}
                <section className="about-three">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="about-three__thumb wow fadeInLeft" data-wow-delay="300ms">
                                    <div className="about-three__thumb__one">
                                        <img src="/assets/images/about/About us.webp?v=20260924" alt="About Hanthana House" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 wow fadeInRight" data-wow-delay="300ms">
                                <div className="about-three__content">
                                    <div className="sec-title text-left">
                                        <h3 className="sec-title__title">Ayubowan from Hanthana House</h3>
                                    </div>
                                    <div>
                                        <p>
                                            We’re Pathi and Suba,the heart behind Hanthana House. In 2017, we built this space to
                                            fulfill our dream of creating a home away from home for travelers. Having lived in the
                                            serene hills of Hanthana for over 25 years, we’ve always loved sharing the beauty of our
                                            surroundings and the warmth of Sri Lankan hospitality with the world.<br /><br />

                                            Pathi brings his years of experience as a National Chauffeur Guide and Travel Agent for
                                            Tikalanka Tours, sharing Sri Lanka’s rich history and culture with our guests. Suba,
                                            known for her exceptional vegetarian cooking,takes pride in preparing authentic rice and
                                            curry dishes, crafted with fresh, homegrown ingredients.<br /><br />

                                            Together, we look forward to welcoming gueststoHanthanaHouse, where they get to
                                            experience the charm of the hills blended with care, warmth, and a touch of home.<br />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Section: Environment in Hanthana */}
                <section className="about-three">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 wow fadeInRight" data-wow-delay="300ms">
                                <div className="about-three__content">
                                    <div className="sec-title text-left">
                                        <h3 className="sec-title__title">Environment in Hanthana</h3>
                                    </div>
                                    <div>
                                        <p>
                                            Hanthana is more than just a destination - it’s a place where nature’s beauty and rich history come together to offer a haven of peace and tranquillity. This quiet hill country village, located southwest of Kandy, has long been cherished for its pristine landscapes. Once part of the Kandyan Kingdom, it was declared a protected forest, preserving its untouched charm and incredible biodiversity.<br /><br />

                                            Here, the hills are alive with wildlife. From leopards and wildboards to playful monkeys and the Sri Lankan Jungle Fowl - the national bird - Hanthana is home to an astonishing variety of species, including over 120 types of birds. If you’re a nature or wildlife enthusiast, this is the place to be. Walking through these hills, you’ll also come across remnants of British-era tea estates, weaving history into the natural surroundings.<br /><br />

                                            Whether you’re here for a day or just a night, Hanthana’s serene environment has a way of soothing the mind and rejuvenating the soul. The cool mountain breeze, the rustling of leaves, and the quiet rhythm of life make it the perfect retreat to recharge and reflect.<br /><br />

                                            If you’re curious about how you connect with this beautiful setting, take a look at <b>Activities</b> to explore what Hanthana has to offer.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="about-three__thumb wow fadeInLeft" data-wow-delay="300ms">
                                    <div className="about-three__thumb__one">
                                        <img src="/assets/images/about/environment.webp?v=20260924" alt="Hanthana Environment" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Section: Testimonials */}
                <Testimonials />
            </main>
            <Footer />
        </>
    )
}

export default About